import { NbDialogService, NbWindowService, NbToastrService } from '@nebular/theme';
import { GetFormFieldComponent } from './../../../../../DynamicFormsModule/formsFields/components/get/get.component';
import { FollowRequestComponent } from './../follow-request/follow-request.component';
import { Component, OnInit, ViewContainerRef, ViewChild, TemplateRef } from '@angular/core';
import { RequestService } from '../../services/request.service';
import { WfRequest } from '../../models/request';

import { GetFormMasterFieldsPopupComponent } from '../../../../../DynamicFormsModule/formsMaster/components/get.fields.popup/get.component';
import { GetFormMasterFieldsValuesComponent } from '../../../../../DynamicFormsModule/formsValues/components/get.fields/get.component';
import { FollowRequestsComponent } from '../follow-requests/follow-requests.component';
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-get-requests',
  templateUrl: './get-requests.component.html',
  styleUrls: ['./get-requests.component.scss'],
})
export class GetRequestsComponent implements OnInit {
  @ViewChild('contentTemplate', { static: false }) contentTemplate: TemplateRef<any>;
  @ViewChild('okcontentTemplate', { static: false }) okcontentTemplate: TemplateRef<any>;

  result: WfRequest[] = [];
  userId: number;
  selectedItem: WfRequest = {} as WfRequest;
  userComment: string;
  okuserComment: string = '';
  nouserComment: string = '';
  windowRf: any;
  flgAction: boolean = false;
  personal: boolean = false;
  role: boolean;
  finishLoading: boolean;
  activeForMakeDecision = false;
  formFlag = {};
  constructor(
    private service: RequestService,
    public viewContainerRef: ViewContainerRef,
    private dialogService: NbDialogService,
    private windowService: NbWindowService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    this.loadRequests();
  }

  loadRequests() {
    this.result = [];
    this.service.getRequestsAssignedToMe().subscribe((result: WfRequest[]) => {
      this.result = result;
      if (this.result != null)
        this.result.forEach((element) => {
          if (element.flgAssignUser == 1) {
            this.personal = true;
          } else {
            this.role = true;
          }
        });

      this.finishLoading = true;
    });
  }
  makeDecision(item: WfRequest, flgAction: number) {
    this.flgAction = false;
    this.selectedItem = item;
    // this.selectedItem.actionUserId = this.service.userId;
    this.selectedItem.flgAction = flgAction;
    this.userComment = '';
    if (flgAction === 1) {
      this.windowRf = this.windowService.open(this.okcontentTemplate, {
        title: 'اتخاذ القرار',
      });
    } else {
      this.windowRf = this.windowService.open(this.contentTemplate, {
        title: 'اتخاذ القرار',
      });
    }

    this.windowRf.onClose.subscribe((res) => {
      this.okuserComment = '';
      this.nouserComment = '';
      if (!this.flgAction) this.toastrService.show('لم يتم حفظ القرار', '');
      else  this.loadRequests();
    });
    // .onClose.subscribe(res => {
    //   this.toastrService.show('لم يتم حفظ القرار', '');
    // });
    // item.actionUserId = this.service.userId;
    // item.flgAction = flgAction;
    // this.service.setDecision(item).subscribe();
  }
  Detail(id: number, unitTypeId: number, criteriaType: number, title: string) {
    // if(unitTypeId === 1){ this.dialogService.open() }
    // if(unitTypeId === 2){ this.dialogService.open() }
    // if(unitTypeId === 1){ this.dialogService.open() }
  }
  saveDecision() {
    this.flgAction = true;
    if (this.okuserComment !== '') {
      this.selectedItem.comment = this.okuserComment;
    } else {
      this.selectedItem.comment = this.nouserComment;
    }
    this.service.setDecision(this.selectedItem).subscribe((res) => {
      this.windowRf.close();
      this.toastrService.show('تم حفظ القرار بنجاح', '');
      this.loadRequests();
    });
  }
  follow(item: any[], isComplete: boolean, requestId) {
    this.dialogService.open(FollowRequestComponent, {
      context: { item: item, complete: isComplete },
    });
  }

  ApplyForm(item, formId) {
    this.dialogService
      .open(GetFormMasterFieldsPopupComponent, {
        context: { formId: formId, refId: item.currentProcessStateId, refType: 'Phase' },
      })
      .onClose.subscribe((res) => {
        if (res === 'false') {
        } else {
          this.result.forEach((res1) => {
            if (res1.id === item.id) {
              res1.currentPhaseAppliedFormId = +res;

              this.service.put(item.id, res1).subscribe();
            }
          });
          //  item.CurrentPhaseAppliedFormId = res;
        }
      });
  }

  detail(formId, id) {
    const initialState = {
      refId: id,
      formId: formId,
      refDataType: 'phase',
    };
    this.dialogService
      .open(GetFormMasterFieldsValuesComponent, {
        context: { refId: id, formId: formId, refDataType: 'Phase' },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') {
          this.loadRequests();
        }
      });
  }

  decisionAvailable(item: any) {
    return item.currentPhaseFormId != null && item.currentPhaseFormId != 0;
  }

  details(item) {
    this.dialogService.open(FollowRequestsComponent, { context: { item: item } }).onClose.subscribe((res) => {
      if (res !== 'false')  this.loadRequests();
    });
  }
}
